import { IsNotEmpty, IsUUID } from 'class-validator';

export class GetEmployeePhotoDto {
  @IsUUID()
  @IsNotEmpty()
  employee_id: string;
}
